module.exports = __webpack_public_path__ + "../resources/images/readingPaneRightLarge-a067abe620f19af3c5a8e2044fae01b7.svg";